export default "__VITE_ASSET__1bbc963a__"